import templateUrl from './display-overview.html';

export const displayOverviewComponent = {
	bindings: {
		details: '<',
		onEdit: '&',
		slugUrl: '@'
	},
	templateUrl,
	controller: class DisplayOverviewComponent {
		constructor($state, SlugService) {
			'ngInject';

			this.$state = $state;
			this.slugService = SlugService;
		}
		$onInit() {
			this.overViewSlugUrl = this.slugService.getOverviewPageUrl(this.slugUrl);
		}

		routeOveriviewPageUrl() {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: this.overViewSlugUrl
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/app/common/components/display-overview/display-overview.component.js